import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import axios from '@/http/http'
import VueTypeJs from 'vue-typed-js'
import {Container,
        Header,
        Main,
        Footer,
        Form,
        Input,
        FormItem,
        Button,
        Checkbox,
        Message,
        Upload,
        Avatar,
        Aside,
        Select,
        Option,
        Col,
        DatePicker,
    TimePicker,
    Switch,
    CheckboxGroup,
    RadioGroup,
    Radio,
    Dialog,
    Result,
    Popconfirm,
    MessageBox,
    Carousel,
    CarouselItem,
    Tag,
    Row,
    Table,
    TableColumn,
    RadioButton,

} from 'element-ui'

Vue.prototype.axios = axios
Vue.config.productionTip = false

Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Form)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Avatar)
Vue.use(Aside)
Vue.use(Select)
Vue.use(Option)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Switch)
Vue.use(CheckboxGroup)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Dialog)
Vue.use(Result)
Vue.use(Popconfirm)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Tag)
Vue.use(Row)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(RadioButton)

Vue.use(VueTypeJs)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm;

new Vue({
    render: h => h(App),
        router,
        store
}).$mount('#app')